"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/usr/src/app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _GTMProvider = require("./GTMProvider");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var _default = function _default() {
  return function (Component) {
    var WithGTM = /*#__PURE__*/function (_react$default$Compon) {
      _inherits(WithGTM, _react$default$Compon);

      var _super = _createSuper(WithGTM);

      function WithGTM() {
        _classCallCheck(this, WithGTM);

        return _super.apply(this, arguments);
      }

      _createClass(WithGTM, [{
        key: "render",
        value: function render() {
          var _this = this;

          return _react.default.createElement(_GTMProvider.GTMConsumer, null, function (gtmData) {
            return _react.default.createElement(Component, _extends({}, _this.props, {
              gtmData: gtmData
            }));
          });
        }
      }]);

      return WithGTM;
    }(_react.default.Component);

    return WithGTM;
  };
};

exports.default = _default;